import {useMemo} from 'react';
import {ISavedSearchTreeViewResponse} from '../../../../api/types/savedsearch.types';

export function useHasMySearch(
  data: ISavedSearchTreeViewResponse[] | undefined,
  selectedIds: string[] | undefined
): boolean {
  const searchGroupMap = useMemo(() => {
    const map = new Map<string, string | undefined>();
    for (const item of data || []) {
      if (item.searchGroupTypeCode === 'MYSEARCH' && item.parent !== '#')
        map.set(item.id, item.searchGroupTypeCode);
    }
    return map;
  }, [data]);

  return useMemo(() => {
    if (!selectedIds?.length) return false;

    for (const id of selectedIds) {
      if (searchGroupMap.get(id)) {
        return true;
      }
    }
    return false;
  }, [selectedIds, searchGroupMap]);
}
